<div
  *ngIf="schema === 'new-primary'; else default"
  role="checkbox"
  tabindex="0"
  class="focus:outline-new-primary relative h-[20px] w-[36px] cursor-pointer rounded focus:outline"
  [attr.aria-checked]="internalChecked"
  (keydown.space)="onSwitchClick(); $event.preventDefault()"
>
  <div
    class="bg-new-primary-p2 absolute top-1/2 h-[12px] w-full -translate-y-1/2 rounded-full"
    [class.bg-petro-n2]="!internalChecked"
  ></div>
  <div
    class="absolute size-[20px] rounded-full bg-white shadow transition-all"
    [class.translate-x-16]="internalChecked"
    [class.translate-x-0]="!internalChecked"
  ></div>
</div>

<ng-template #default>
  <span
    class="switch"
    [class.checked]="internalChecked"
    [class.disabled]="disabled"
    [class.switch-large]="size === 'large'"
    [class.switch-medium]="size === 'medium'"
    [class.switch-small]="size === 'small'"
    [style.background-color]="internalChecked ? color : backgroundColor"
    [style.border-color]="internalChecked ? color : borderColor"
  >
    <small></small>
  </span>
</ng-template>
